import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ backgroundUrl: string; maxHeight?: number }>()(
  (theme, { backgroundUrl, maxHeight = 23.75 }) => ({
    root: {
      width: '100%',
      height: theme.spacing(maxHeight),
      minHeight: theme.spacing(23.75),
      maxHeight: theme.spacing(maxHeight),
      flex: 1,
      backgroundBlendMode: 'multiply',
      backgroundImage: `url(${backgroundUrl})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      alignItems: 'stretch',
      textShadow: `black 0 0 ${theme.spacing(5)}, black 0 0 ${theme.spacing(4)}`,
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      lineHeight: 1,
      textAlign: 'center',
      fontSize: `max(${theme.spacing(4.5)}, min(${theme.spacing(9)}, 5vw))`,
      fontFamily: 'Bebas Neue',
    },
    text: {
      textAlign: 'center',
      textShadow: [
        `black ${theme.spacing(0.125, 0.125, 0.5)}`,
        `black ${theme.spacing(-0.125, -0.125, 1.25)}`,
      ].join(', '),
    },
  })
);
